import { Button } from '@superops/ui-design-system';
import { cloneDeep } from 'lodash';
import React from 'react';
import { withErrorBoundary, getTranslatedText } from '@nile/components';
import { FormattedMessage } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';
import { getGlobalEntityAttributes } from '@nile/reports/src/modules/component/helper';
import GroupByItem from '@nile/reports/src/modules/component/GroupBy/GroupByItem';

function GroupBy(props) {
  const { intl, meta, validateChartForm, context, errors, metaLoading } = props;

  const formattedMeta = getGlobalEntityAttributes(intl, meta, [
    context?.value?.entity
  ]);

  const { groupByAttributes: grpByAttr, groupAttributes } = formattedMeta;

  const groupByAttributes = grpByAttr.map((attr) => ({
    ...attr,
    value: attr?.attributePlaceHolder?.label
      ? getTranslatedText(intl, attr?.attributePlaceHolder?.label)
      : '',
    label: attr?.attributePlaceHolder?.label
      ? getTranslatedText(intl, attr?.attributePlaceHolder?.label)
      : ''
  }));

  const addGroupByHandler = () => {
    let updatedGroupBy = cloneDeep(context?.value?.groupBy);
    if (!updatedGroupBy) {
      updatedGroupBy = [];
    }
    updatedGroupBy = [...updatedGroupBy, { attribute: null }];
    context.updateContext({ ...context.value, groupBy: updatedGroupBy });
  };

  return (
    <div className="grpby">
      <div className="flex fx-sb actr">
        <div className="bold uppercase">
          <FormattedMessage id="reports.chart.config.groupBy" />
        </div>
        {(context?.value?.groupBy === null ||
          context?.value?.groupBy?.length < 2) && (
          <Button
            onClick={addGroupByHandler}
            disabled={context?.value?.groupBy?.length === 2}
            icon={<SVGIcon name="Add" />}
          />
        )}
      </div>
      {context?.value?.groupBy?.length > 0 && (
        <div className="mbt10">
          {context?.value?.groupBy?.map((grpBy, ind) => (
            <GroupByItem
              key={`${grpBy?.attribute}-${ind}`}
              validateChartForm={validateChartForm}
              data={grpBy}
              index={ind}
              groupByAttributes={groupByAttributes}
              groupedEntities={groupAttributes}
              context={context}
              intl={intl}
              metaLoading={metaLoading}
              errors={errors?.[0]?.errors?.[ind]?.error}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default withErrorBoundary(GroupBy);
